<template>
  <main style="opacity: 0;">
    <div class="block">
     <Paragraph
        size="small"
        :text="structure.main.data.role"
        class="block__eyelet"
        data-anim="fade"
        data-view="false"
      />
      <div :data-nav="$route.params.id" data-navproject="true">
        <Title
          size="team"
          :text="structure.main.data.title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>

      <div class="block__content">
        <figure class="block__figure" data-anim="fade">
          <img :src="structure.main.data.image" :alt="structure.main.data.title" />
        </figure>

        <Paragraph
          size="small"
          :text="structure.main.data.text"
          data-anim="stagger-fade"
          data-view="false"
        />

        <component
          v-for="(component, key) in structure.extra"
          :key="key"
          :is="component.component"
          :data="component"
        >
        </component>
      </div>
    </div>
  </main>
</template>

<script>
import translate from '@/assets/i18n';

import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import List from '@/components/text/List.vue';
import Detail from '@/components/text/Detail.vue';
import Link from '@/components/text/Link.vue';
import BulletList from '@/components/BulletList.vue';
import BlockText from '@/components/BlockText.vue';

export default {
  name: 'Project',

  components: {
    Title,
    Paragraph,
    Detail,
    List,
    Link,
    BulletList,
    BlockText,
  },

  data() {
    return {
      translate,
    };
  },

  computed: {
    structure() {
      const parsedStructure = {
        main: null,
        extra: [],
      };

      const data = this.$store.state.firebase.team.childrens[this.$store.state.routeName];
      const { lang } = this.$store.state;
      const structure = data.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        if (structure[key].component === 'TeamDetails' && parsedStructure.main === null) {
          parsedStructure.main = structure[key];
        } else {
          parsedStructure.extra.push(structure[key]);
          parsedStructure.extra.sort((a, b) => a.order - b.order);
        }
      });

      return parsedStructure;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__figure {
    @include mq($and: $is-hover) {
      display: none !important;
    }

    @media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm) {
      z-index: 100;
      mix-blend-mode: multiply;
    }

    img {
      mix-blend-mode: multiply;
      opacity: 0.7;
    }

    max-width: 900px;
    margin-bottom: rem(60px);
  }

  &__details {
    padding-top: rem(20px);
  }

  &__content {
    margin-top: rem(120px);

    @include mq($and: $is-touch-device) {
      margin-top: rem(80px);
    }

    p {
      margin-top: rem(60px);
    }
  }

  &__link {
    margin-top: rem(120px);
  }
}
</style>
